var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.playlist),function(item){return _c('li',{key:item.id,attrs:{"data":item},on:{"click":function($event){return _vm.$emit('select-song', item)}}},[_c('span',[_vm._v(_vm._s(item.song)+" "+_vm._s(item.artist))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }